export enum BalanceType {
    Outstanding = 1,
    Credit = 2,
    Voucher = 3
}